<template>
  <v-app>
    <cv-header></cv-header>
    <v-main>
      <router-view> </router-view>
    </v-main>
  </v-app>
</template>

<script>
import CvHeader from '@/components/common/CvHeader';

//import LoginForm from '@/components/LoginForm.vue';
export default {
  components: {
    //LoginForm,
    CvHeader,
  },
  mounted: function() {
    console.log(this.$route.params);
    this.$store.commit('setTenant', this.$route.params.tenantKey);
  },
};
</script>
